var React = require('react');

function Frigate (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Frigate"),React.createElement("path",{"id":"path877-6-5","className":"cls-1","d":"M114,90.91l-50-50-50,50Z","key":2})]);
}

Frigate.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Frigate;

Frigate.default = Frigate;
